export default "__VITE_ASSET__JsTgiNNX__"